export default "__VITE_ASSET__BgZHVZaw__"